(function () {
  function slideWidth(track) {
    var slide = track.querySelector('.mm-feat__slide');
    if (!slide) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function visibleCount() {
    if (window.matchMedia('(max-width: 749px)').matches) return 4;
    if (window.matchMedia('(max-width: 989px)').matches) return 2;
    return 4;
  }

  function isMobileGrid() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function bindSlider(panel) {
    var track = panel.querySelector('[data-mm-feat-track] .mm-feat__track');
    var viewport = panel.querySelector('[data-mm-feat-track]');
    var prev = panel.querySelector('[data-mm-feat-prev]');
    var next = panel.querySelector('[data-mm-feat-next]');
    var dotsWrap = panel.querySelector('[data-mm-feat-dots]');
    if (!track || !viewport) return;

    var index = 0;
    var slides = track.querySelectorAll('.mm-feat__slide');

    function pageCount() {
      var vis = visibleCount();
      return Math.max(1, Math.ceil(slides.length / vis));
    }

    function renderDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = pageCount();
      if (pages <= 1 || isMobileGrid()) {
        dotsWrap.innerHTML = '';
        return;
      }
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm-feat__dot' + (i === index ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        btn.addEventListener('click', function (page) {
          return function () {
            goTo(page);
          };
        }(i));
        dotsWrap.appendChild(btn);
      }
    }

    function goTo(page) {
      if (isMobileGrid()) {
        track.style.transform = 'none';
        index = 0;
        return;
      }
      var pages = pageCount();
      index = Math.max(0, Math.min(page, pages - 1));
      var offset = index * visibleCount() * slideWidth(track);
      track.style.transform = 'translateX(' + -offset + 'px)';
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.mm-feat__dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(index - 1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    window.addEventListener('resize', function () {
      renderDots();
      goTo(0);
    });

    panel._mmFeatGoTo = goTo;
    panel._mmFeatRenderDots = renderDots;
    renderDots();
    goTo(0);
  }

  function activate(root, index) {
    var tabs = root.querySelectorAll('[data-mm-feat-tab]');
    var panels = root.querySelectorAll('[data-mm-feat-panel]');
    var select = root.querySelector('[data-mm-feat-select]');

    tabs.forEach(function (tab) {
      var active = parseInt(tab.getAttribute('data-index'), 10) === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var active = parseInt(panel.getAttribute('data-index'), 10) === index;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (active && panel._mmFeatGoTo) {
        panel._mmFeatRenderDots && panel._mmFeatRenderDots();
        panel._mmFeatGoTo(0);
      }
    });

    if (select) select.value = String(index);
  }

  function init(root) {
    if (!root || root.dataset.mmFeatBound === 'true') return;
    root.dataset.mmFeatBound = 'true';

    root.querySelectorAll('[data-mm-feat-panel]').forEach(bindSlider);

    root.querySelectorAll('[data-mm-feat-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(root, parseInt(tab.getAttribute('data-index'), 10) || 0);
      });
    });

    var select = root.querySelector('[data-mm-feat-select]');
    if (select) {
      select.addEventListener('change', function () {
        activate(root, parseInt(select.value, 10) || 0);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-mm-feat]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-mm-feat]');
    if (root) {
      delete root.dataset.mmFeatBound;
      init(root);
    }
  });
})();
